import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 导入翻译文件
import enTranslation from './locales/en.json';
import zhTranslation from './locales/zh.json';

// 支持的语言
const resources = {
  en: {
    translation: enTranslation
  },
  zh: {
    translation: zhTranslation
  }
};

// 初始化i18n
i18n
  // 自动检测用户语言
  .use(LanguageDetector)
  // 将i18n实例传递给react-i18next
  .use(initReactI18next)
  .init({
    resources,
    // 默认语言
    fallbackLng: 'en',
    // 调试模式
    debug: import.meta.env.DEV,
    // 插值配置
    interpolation: {
      escapeValue: false, // React已经处理了XSS
      format: (value, format, lng) => {
        // 格式化时间等特殊值
        if (format === 'date' && value) {
          return new Date(value).toLocaleDateString(lng);
        }
        return value;
      }
    },
    // 语言检测配置
    detection: {
      order: ['localStorage', 'cookie', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie']
    },
    // 支持的语言列表
    supportedLngs: ['en', 'zh'],
    // 允许部分匹配语言
    load: 'currentOnly'
  });

export default i18n;
